(function () {
  'use strict';

  var DISCOUNT_FACTOR = 0.75;
  var COLLECTION_PATH = '/collections/ready-to-ship';

  function discountedCents(cents) {
    return Math.round(Number(cents) * DISCOUNT_FACTOR);
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && typeof window.moneyFormat !== 'undefined') {
      return window.Shopify.formatMoney(cents, window.moneyFormat);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function parseDisplayedPrice(text) {
    var normalized = String(text || '').replace(/,/g, '');
    var match = normalized.match(/\d+(?:\.\d{1,2})?/);
    if (!match) return null;
    return Math.round(parseFloat(match[0]) * 100);
  }

  function isReadyToShipCollection() {
    var path = window.location.pathname.replace(/\/$/, '');
    return path === COLLECTION_PATH || path.indexOf(COLLECTION_PATH + '/') === 0;
  }

  function addSaleBadge(card) {
    var imageArea = card.querySelector('.yv-product-card-img');
    if (!imageArea || imageArea.querySelector('.rts-sale-badge')) return;

    var badge = document.createElement('div');
    badge.className = 'yv-product-badge sale-badge rts-sale-badge';
    badge.textContent = '25% OFF';
    imageArea.appendChild(badge);
  }

  function updatePriceBox(priceBox) {
    if (!priceBox || priceBox.dataset.rtsSaleApplied === 'true') return;

    var priceElement = priceBox.querySelector('.yv-product-price');
    if (!priceElement) return;

    var originalCents = parseDisplayedPrice(priceElement.textContent);
    if (originalCents === null) return;

    var varies = priceElement.classList.contains('price-varies');
    priceElement.textContent = (varies ? 'From ' : '') + formatMoney(discountedCents(originalCents));

    var compareElement = priceBox.querySelector('.yv-product-compare-price');
    if (!compareElement) {
      compareElement = document.createElement('span');
      compareElement.className = 'yv-product-compare-price';
      priceBox.appendChild(compareElement);
    }
    compareElement.textContent = formatMoney(originalCents);

    var offElement = priceBox.querySelector('.yv-product-percent-off');
    if (!offElement) {
      offElement = document.createElement('span');
      offElement.className = 'yv-product-percent-off rts-percent-off';
      priceBox.appendChild(offElement);
    }
    offElement.textContent = '25% OFF';

    priceBox.dataset.readyToShipSale = 'true';
    priceBox.dataset.rtsSaleApplied = 'true';
  }

  function updateCollectionCards(root) {
    if (!isReadyToShipCollection()) return;
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.yv-product-card').forEach(function (card) {
      updatePriceBox(card.querySelector('.yv-prizebox'));
      addSaleBadge(card);
    });

    scope.querySelectorAll('.quick-add-popup .yv-prizebox, .yv_side_drawer_wrapper .yv-prizebox').forEach(updatePriceBox);
  }

  function wrapThemePriceUpdater() {
    if (typeof window.priceUpdate !== 'function' || window.priceUpdate.rtsWrapped) return;

    var originalPriceUpdate = window.priceUpdate;
    var wrapped = function (productSection, priceContainer, variant, showSaved) {
      if (priceContainer && priceContainer.dataset.readyToShipSale === 'true' && variant) {
        var saleVariant = Object.assign({}, variant);
        var originalPrice = Number(variant.price);
        saleVariant.price = discountedCents(originalPrice);
        saleVariant.compare_at_price = originalPrice;
        return originalPriceUpdate(productSection, priceContainer, saleVariant, showSaved);
      }
      return originalPriceUpdate(productSection, priceContainer, variant, showSaved);
    };

    wrapped.rtsWrapped = true;
    window.priceUpdate = wrapped;
  }

  function injectStyles() {
    if (document.getElementById('rts-sale-display-styles')) return;
    var style = document.createElement('style');
    style.id = 'rts-sale-display-styles';
    style.textContent = [
      '.rts-sale-badge{background:#a00404!important;color:#fff!important;font-weight:700!important;}',
      '.rts-percent-off{margin-left:8px;font-weight:700;color:#a00404;}',
      '[data-ready-to-ship-sale="true"] .yv-product-price{font-weight:700;}',
      '[data-ready-to-ship-sale="true"] .yv-product-compare-price{text-decoration:line-through;opacity:.7;margin-left:8px;}'
    ].join('');
    document.head.appendChild(style);
  }

  function initialize() {
    injectStyles();
    wrapThemePriceUpdater();
    updateCollectionCards(document);

    var observer = new MutationObserver(function (mutations) {
      wrapThemePriceUpdater();
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) updateCollectionCards(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
